/** Шаг перемотки стрелкой и стрелкой с Shift, секунды. */
export const SEEK_STEP_SEC = 1;
export const SEEK_STEP_LARGE_SEC = 5;

const clamp = (value: number, duration: number) => Math.min(duration, Math.max(0, value));

/** Время под указателем на полосе прогресса: доля ширины полосы × длительность. */
export function seekFromPointer(
  clientX: number,
  rect: Pick<DOMRect, 'left' | 'width'>,
  duration: number,
): number {
  if (duration <= 0 || rect.width <= 0) return 0;
  return clamp(((clientX - rect.left) / rect.width) * duration, duration);
}

/**
 * Перемотка с клавиатуры, пока полоса в фокусе: ←/→ на секунду, с Shift — на пять,
 * Home и End — к началу и к концу. null — клавиша не про перемотку.
 */
export function seekFromKey(
  key: string,
  shiftKey: boolean,
  current: number,
  duration: number,
): number | null {
  if (duration <= 0) return null;
  const step = shiftKey ? SEEK_STEP_LARGE_SEC : SEEK_STEP_SEC;
  switch (key) {
    case 'ArrowLeft':
    case 'ArrowDown':
      return clamp(current - step, duration);
    case 'ArrowRight':
    case 'ArrowUp':
      return clamp(current + step, duration);
    case 'Home':
      return 0;
    case 'End':
      return duration;
    default:
      return null;
  }
}
